import AppointmentOrderSuccess from './AppointmentOrderSuccess'

export default AppointmentOrderSuccess